/**
 * The text of a thrown value, for a log line or a JSON error field.
 *
 * `catch (error)` hands over `unknown`: a library, a rejected fetch in another
 * realm or a bare `throw 'x'` can all produce something that is not an Error.
 * These were pasted inline as `error instanceof Error ? error.message : ...`
 * in hundreds of handlers; one tested copy keeps them identical.
 */

/** The Error's message, or `fallback` for anything else. */
export function errorMessageOr(error: unknown, fallback: string): string {
  return error instanceof Error ? error.message : fallback;
}

/** The Error's message, or the thrown value as a string. */
export function errorText(error: unknown): string {
  return error instanceof Error ? error.message : String(error);
}

/**
 * The thrown value as an Error, so a logger that wants one gets a name and a
 * stack: the Error itself, or a new one carrying the value as its message.
 */
export function asError(error: unknown): Error {
  return error instanceof Error ? error : new Error(String(error));
}
